import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { computed } from "@vue/composition-api";
export const useAddress = address => {
  const unitNumber = address != null && address["unit-number"] ? `${address["unit-number"]}-` : "";
  const line1Arr = [unitNumber, (address == null ? void 0 : address["street-number"]) || "", (address == null ? void 0 : address["street-name"]) || "", (address == null ? void 0 : address["street-type"]) || "", (address == null ? void 0 : address["street-direction"]) || ""];
  const constructedLine1 = _filterInstanceProperty(line1Arr).call(line1Arr, addressComponent => !!addressComponent).join(" ");
  const fullAddressArr = [constructedLine1, (address == null ? void 0 : address.city) || "", (address == null ? void 0 : address.province) || "", (address == null ? void 0 : address["postal-code"]) || ""];
  const fullAddress = computed(() => _filterInstanceProperty(fullAddressArr).call(fullAddressArr, addressComponent => !!addressComponent).join(", "));
  const isAddressComplete = computed(() => fullAddressArr.every(addressComponent => !!addressComponent));
  return {
    fullAddress,
    isAddressComplete
  };
};